import React, { useMemo } from "react";
import { useSalidas } from "../../Context/SalidasContext";
import Grid from "@material-ui/core/Grid";
import style from "../../assets/jss/disal-main/Layouts/Ingresos";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Modal from "../../Component/Modal/ModalSalida";
import Pagination from "../../Component/Pagination/PaginationPatio";
import { DatePicker, message } from "antd";
import "antd/dist/antd.css";
import moment from "moment";

const useStyles = makeStyles(style);
const SalidasContent = () => {
  const classes = useStyles();
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const {
    miningSite,
    totalPages,
    salidas,
    warehouse,
    warehouses,
    fromDay,
    toDay,
    selected,
    setPage,
    setSelected,
    setMiningSite,
    setWarehouse,
    setFromDay,
    setToDay
  } = useSalidas();

  const title = useMemo(() => {
    if(miningSite === 0 && warehouse === 0){
      return "Mostrando salida de residuos para todas las plantas";
    } else if(miningSite !== 0 && warehouse === 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      return "Mostrando salida de residuos para todos los patios de " + miningSiteName;
    } else if(miningSite !== 0 && warehouse !== 0){
      const miningSiteName = miningSites.find((res) => res.id === miningSite).name;
      const warehouseName = warehouses.find((res) => res.id === warehouse).name;
      return "Mostrando salida de residuos para " + warehouseName + " de " + miningSiteName;
    }
    return "";
  }, [miningSite, warehouse, miningSites, warehouses]);

  const validateFromDay = (value) => {
    const newFromDay = moment(value);

    if(newFromDay.isAfter(toDay)){
      message.error(
        `La fecha debe ser igual o menor a la fecha ${toDay.format("DD/MM/YYYY")}`,
        1.5
      );
      setFromDay(toDay);
    }else{
      setFromDay(newFromDay);
    }
  };

  const validateToDay = (value) => {
    const newToDay = moment(value);

    if(newToDay.isBefore(fromDay)){
      message.error(
        `La fecha debe ser igual o mayor a la fecha ${fromDay.format("DD/MM/YYYY")}`,
        1.5
      );
      setToDay(fromDay);
    }else{
      setToDay(newToDay);
    }
  };

  return (
    <Grid container className={classes.ingresos}>
      <h4>Revisa las salidas de residuos de Patio Temporal</h4>
      <Grid item sm={12}>
        <Grid container>
          <Grid item sm={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={miningSite}
                onChange={(e) => {
                  setMiningSite(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos las plantas</MenuItem>
                {miningSites.map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
            >
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={warehouse}
                disabled={miningSite === 0}
                onChange={(e) => {
                  setWarehouse(e.target.value);
                }}
              >
                <MenuItem value={0}>Todos los Patios</MenuItem>
                {warehouses.filter((yard) => yard.mining_site_id === miningSite).map((res, key) => {
                  return (
                    <MenuItem key={key} value={res.id}>
                      {res.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <label>
                <strong>Del: </strong>
            </label>
            <DatePicker
              value={fromDay}
              onChange={validateFromDay}
              size="large"
              className="header-select"
              placeholder="Desde"
              format="DD/MM/YYYY"
              maxDate={toDay}
            />
          </Grid>
          <Grid item sm={2}>
            <label>
                <strong>Al: </strong>
            </label>
            <DatePicker
              value={toDay}
              onChange={validateToDay}
              size="large"
              className="header-select"
              placeholder="Desde"
              format="DD/MM/YYYY"
              minDate={fromDay}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12} className={classes.mainTable}>
        <h3
          style={{
            color: "#0D0D0D",
            fontFamily: "Roboto",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "20px",
            textAlign: "left",
          }}
        >
          {title}
        </h3>
        <TableContainer className={classes.contentTable}>
          <Table
            className={classes.tableGeneral}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow className={classes.cellOperativo}>
                <TableCell>Fecha</TableCell>
                <TableCell>Hora</TableCell>
                <TableCell>Planta</TableCell>
                <TableCell>Patio</TableCell>
                <TableCell>Transportista</TableCell>
                <TableCell>Destino</TableCell>
                <TableCell>Peso Total(Ton.)</TableCell>
                <TableCell>Detalle</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {salidas.map((item, index) =>
                <TableRow key={"row-data-" + index}>
                  <TableCell>{item.outputDate !== null ? item.outputDate : "-"}</TableCell>
                  <TableCell>{item.outputTime !== null ? item.outputTime : "-"}</TableCell>
                  <TableCell>{item.miningSiteName !== null ? item.miningSiteName : "-"}</TableCell>
                  <TableCell>{item.warehouseName !== null ? item.warehouseName : "-"}</TableCell>
                  <TableCell>{item.transportCompanyName !== null ? item.transportCompanyName : "-"}</TableCell>
                  <TableCell>{item.destinationCompanyName !== null ? item.destinationCompanyName : "-"}</TableCell>
                  <TableCell>{item.totalAmount !== null ? (parseFloat(item.totalAmount) / 1000).toFixed(2) : "-"}</TableCell>
                  <TableCell>
                    <button
                      type="button"
                      className="btn-ingresos"
                      id={index}
                      data-id={item.inputId}
                      onClick={() => setSelected(item)}
                    >
                      Ver detalle
                    </button>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Pagination
        totalRecords={totalPages}
        pageLimit={15}
        initialPage={1}
        pageToShow={4}
        onChangePage={({ page }) => setPage(page)}
      />
      {selected && (
        <Modal
          onClose={() => setSelected(null)}
          data={selected}
        />
      )}
    </Grid>
  );
};

export default SalidasContent;
